import React from "react"
import SEO from "../components/seo"
import { graphql } from "gatsby"
import Container from "@material-ui/core/Container"
import Grid from "@material-ui/core/Grid"
import { Typography, Divider } from "@material-ui/core"

const FaqsPage = props => {
  return (
    <section>
      <SEO title="Home" />
      <Grid item sm={12} style={{ marginTop: "3em", marginBottom: "3em" }}>
        <Typography
          variant="h4"
          style={{
            textAlign: "center",
            marginBottom: ".5em",
            fontStyle: "italic",
            fontWeight: "bold",
          }}
        >
          Frequently Asked Questions
        </Typography>
      </Grid>
      <Container>
        {props.data.allFaq.edges.map(({ node }, index) => (
          <React.Fragment>
            <Divider variant="inset" />
            <Grid
              className={`feature ${index % 2 === 0 ? "left" : "right"}`}
              key={node.id}
              container
              justify="center"
              alignContent="center"
              style={{ marginBottom: "2em" }}
            >
              <Grid item xs={12}>
                <Typography variant="h5" style={{ marginTop: "2em" }}>
                  {node.question}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography>{node.answer}</Typography>
              </Grid>
            </Grid>
          </React.Fragment>
        ))}
      </Container>
    </section>
  )
}

export const query = graphql`
  {
    allFaq {
      edges {
        node {
          id
          answer
          question
          order
        }
      }
    }
  }
`

export default FaqsPage
